import { useEffect, useState } from "react";
import { fetchTaxGroups, fetchTaxRules, TaxGroup, TaxRule } from "./Manualtaxandtaxrules";

export function useTaxData(token: string) {
  const [taxGroups, setTaxGroups] = useState<TaxGroup[]>([]);
  const [taxRules, setTaxRules] = useState<TaxRule[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [groups, rules] = await Promise.all([
          fetchTaxGroups(token),
          fetchTaxRules(token),
        ]);
        if (!alive) return;
        setTaxGroups(groups || []);
        setTaxRules(rules || []);
      } catch (e: any) {
        if (!alive) return;
        setError(e?.message || "Failed to load tax data");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [token]);

  return { taxGroups, taxRules, loading, error };
}
